// dealOwnershipHints.ts — cross-RLS duplicate/ownership hints (Jul 14, 2026)
//
// RMs can only read their own + split deals, so a client-side deals query
// can't tell them "this lead already exists but belongs to another rep" —
// which is exactly how duplicates get created (an RM searches, sees nothing,
// logs a new lead). The find_deal_ownership_hints RPC runs as definer and
// returns a LIMITED hint for LIVE deals only: homeowner, street, stage,
// owner name + phone. No financials, and the deal row itself stays
// RLS-protected — the hint just tells the rep who to call for split access.
//
// Used by: UniversalSearch (free-text) and ManualEntryModal (structured).

import { supabase } from "./supabase";

export interface DealOwnershipHint {
  id: string;
  homeowner_name: string | null;
  property_street: string | null;
  property_city: string | null;
  stage: string | null;
  created_at: string | null;
  owner_name: string | null;
  owner_phone: string | null;
  split_name: string | null;
}

export async function findDealOwnershipHints(args: {
  query?: string;
  street?: string;
  city?: string;
  phone?: string;
}): Promise<DealOwnershipHint[]> {
  try {
    const { data, error } = await supabase.rpc("find_deal_ownership_hints", {
      p_query: args.query ?? null,
      p_street: args.street ?? null,
      p_city: args.city ?? null,
      p_phone: args.phone ?? null,
    });
    if (error || !Array.isArray(data)) return [];
    return data as DealOwnershipHint[];
  } catch {
    return [];
  }
}
